import { render, staticRenderFns } from "./FaxReportBar.vue?vue&type=template&id=4257df1e"
import script from "./FaxReportBar.vue?vue&type=script&lang=js"
export * from "./FaxReportBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports